// DeleteModal.jsx
import React from "react";
import { Modal, Button } from "antd";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const DeleteModal = ({ visible, onCancel, onConfirm }) => {
  const { language } = useLanguage();
  const text = dashboardContent[language].feedback.deleteModal;
  return (
    <Modal
      title={text.title}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <div style={{ textAlign: "center" }}>
        <h2>{text.confirm}</h2>
        <p>{text.warning}</p>
        <div style={{ marginTop: "20px" }}>
          <Button onClick={onCancel} style={{ marginRight: "10px" }}>
            {text.cancel}
          </Button>
          <Button type="primary" danger onClick={onConfirm}>
            {text.delete}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
